import './Button.css'

import { useState } from 'react'

import { Icon, type IconName } from './Icon'

type buttonProps = {
    icon: IconName | null
    label: string
    size?: 'small' | 'medium' | 'large'
    long?: boolean
    transparent?: boolean
    hoverColor?: string
    align?: 'start' | 'center' | 'end'
    btnType?: 'approve' | 'reject'
    [key: string]: any
}

export default function Button({ icon, label, size = 'medium', long = false, transparent = false, hoverColor = 'white', align = 'center', btnType, ...props }: buttonProps) {
    const [color, setColor] = useState('white')

    let classes = transparent ? 'transparent ' : ''
    if (long) classes += 'long '
    if (size) classes += `size-${size} `

    let containerClasses = 'button-container ' + `align-${align}`

    const hoverProps = hoverColor !== 'white' ? { onMouseEnter: () => setColor(hoverColor), onMouseLeave: () => setColor('white') } : {}

    if (btnType === 'approve') {
        classes += 'approve '
    } else if (btnType === 'reject') {
        classes += 'reject '
    }

    if (props.className) {
        classes += props.className
        delete props.className
    }

    return (
        <div className={containerClasses}>
            <button
                style={{ color: color }}
                className={classes}
                {...hoverProps}
                {...props}>
                {icon && (
                    <span className='button-icon'>
                        <Icon name={icon} />
                    </span>
                )}
                <span className='button-label'>{label}</span>
            </button>
        </div>
    )
}
